import Component from '../core/Component';
import $ from 'jquery';

export default class Video extends Component {
    constructor($element) {
        super($element);
        this.done = false;
    }

    prepare() {
        this.$element.click((event) => {
            if (!this.done) {
                event.preventDefault();
                var href = $(event.currentTarget).data('address');
                this.$element.append(`<video src="${href}" autoplay="true"></video>`);
                this.done = true;
                this.$element.addClass('is-playing');
                
                setTimeout(() =>{
                   this.$element.find('video').attr('controls', "controls") 
                }, 400);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/Video.js